<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section>
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active"><a (click)="resetAllFilters()">Shops</a></li>
      <li *ngIf="selectedCategory?.title">
        <ion-icon name="chevron-forward-outline"></ion-icon>
        <a (click)="resetLetterFilter()">{{selectedCategory.title}}</a>
      </li>
      <li *ngIf="filteredBy">
        <ion-icon name="chevron-forward-outline"></ion-icon>
        <a (click)="resetCategoryFilter()">{{filteredBy | uppercase}}</a>
      </li>
    </ul>

    <!-- HEADING & CATEGORY SELECT -->
    <ion-row class="listing-header ion-align-items-center">
      <ion-col class="ion-no-padding">
        <ion-text color="dark">
          <h1 class="h2 page-title">{{data?.title | uppercase}}</h1>
        </ion-text>
      </ion-col>
      <!-- <ion-col
        size="auto"
        size-md="3"
        class="ion-no-padding ion-justify-content-end ion-text-right">
        <ion-text class="select-trigger" (click)="presentPopover($event)">
          <ion-text class="select-text">Filter Stores</ion-text>
        </ion-text>
      </ion-col> -->
    </ion-row>

    <ion-content
      scrollX="true"
      scrollY="false"
      class="filter-wrapper"
      *ngIf="filters">
      <div>
        <a
          *ngFor="let filter of filters"
          (click)="filterByLetter(filter, true)"
          [class.active]="filteredBy === filter.toLowerCase()"
          class="filter-item"
          >{{filter}}</a
        >
      </div>
    </ion-content>

    <div class="results-wrapper">
      <ion-text class="h5"
        >Viewing {{ selectedCategory ? getFilteredRecords() :
        this.data.items.length }} store results which match your
        filter</ion-text
      >
    </div>
    <div class="filter-container ion-hide-md-down">
      <app-button
        [ngClass]="{ 'active-filter': !selectedCategory }"
        class="filter-btn"
        type="secondary"
        (click)="resetAllFilters()">
        All categories
      </app-button>
      <app-button
        (click)="filterByCategory(category)"
        [ngClass]="{ 'active-filter': selectedCategory?.slug === category.slug }"
        *ngFor="let category of (isExpanded ? data.categories : data.categories.slice(0, 6))"
        type="secondary"
        class="filter-btn"
        >{{category.title}}</app-button
      >

      <app-button
        class="toggle-btn"
        (click)="toggleCategoryView()"
        [icon]="{ name: 'plus', position: 'left' }">
        {{ isExpanded ? 'View Less' : 'View All' }}
      </app-button>
    </div>

    <div class="ion-hide-md-up">
      <app-button
        class="mobi-filter"
        type="secondary"
        [icon]="menuIcon"
        [fullWidth]="true"
        (click)="openCategoryFilterModal()">
        filter by category
      </app-button>
    </div>

    <!-- Modal for Category Filter -->
    <ion-modal class="floating" [(isOpen)]="isModalOpen">
      <ng-template>
        <!-- Modal Header -->
        <div class="modal-header ion-padding">
          <ion-title class="modal-title">Select a category</ion-title>
          <ion-icon
            name="close-outline"
            slot="end"
            class="close-icon"
            (click)="closeCategoryFilterModal()">
          </ion-icon>
        </div>

        <!-- Modal Content -->
        <ion-content class="modal-content">
          <ion-list>
            <ion-radio-group [(ngModel)]="selectedCategory">
              <!-- Iterate over categories -->
              <ion-item class="category-item" lines="none">
                <ion-radio
                  slot="start"
                  value="all_categories"
                  class="radio-button">
                </ion-radio>
                <ion-label class="category-label"> All categories</ion-label>
              </ion-item>
              <ion-item
                *ngFor="let category of data.categories"
                class="category-item"
                lines="none">
                <ion-radio slot="start" [value]="category" class="radio-button">
                </ion-radio>
                <ion-label class="category-label"
                  >{{ category.title }}</ion-label
                >
              </ion-item>
            </ion-radio-group>
          </ion-list>
        </ion-content>

        <!-- Footer Button -->
        <div class="modal-footer ion-padding">
          <ion-button
            expand="block"
            class="view-results-button"
            (click)="applyFilter()">
            View Results
          </ion-button>
        </div>
      </ng-template>
    </ion-modal>

    <ion-row
      class="ion-align-items-center"
      [ngClass]="selectedCategory && 'listing-subheader '">
      <ion-col class="ion-no-padding">
        <ion-text color="dark">
          <h3 class="h3 page-title ion-text-uppercase" *ngIf="selectedCategory">
            {{selectedCategory.title}}
          </h3>
          <ion-text *ngIf="selectedCategory?.seoDescription">
            {{selectedCategory.seoDescription}}
          </ion-text>
        </ion-text>
      </ion-col>
    </ion-row>

    <!-- LISTING GRID -->
    <div *ngIf="!stores" class="stores-listing">
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md="3" *ngFor="let item of [1,2,3,4]">
            <ion-card class="card-boxed">
              <div class="card-img">
                <ion-skeleton-text
                  animated
                  class="text-animated"></ion-skeleton-text>
              </div>
              <ion-card-header>
                <ion-card-subtitle
                  ><ion-skeleton-text animated class="w-70"></ion-skeleton-text
                ></ion-card-subtitle>
                <ion-card-title
                  ><ion-skeleton-text animated class="w-50"></ion-skeleton-text
                ></ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ion-skeleton-text animated class="w-100"></ion-skeleton-text>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="desktop">
          <ion-col size="12" size-md="3" *ngFor="let item of [1,2,3,4]">
            <ion-card class="card-boxed">
              <div class="card-img">
                <ion-skeleton-text
                  animated
                  class="text-animated"></ion-skeleton-text>
              </div>
              <ion-card-header>
                <ion-card-subtitle
                  ><ion-skeleton-text animated class="w-70"></ion-skeleton-text
                ></ion-card-subtitle>
                <ion-card-title
                  ><ion-skeleton-text animated class="w-50"></ion-skeleton-text
                ></ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ion-skeleton-text animated class="w-100"></ion-skeleton-text>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div *ngIf="stores" class="stores-listing">
      <ng-container *ngIf="(stores && stores.length === 0); else storesList">
        <ion-text class="no-stores-text">
          <h3
            *ngIf="filteredBy; else noStores"
            class="ion-margin-vertical ion-padding-vertical">
            There are currently no stores starting with the letter
            <strong>{{filteredBy}}</strong>
          </h3>
          <ng-template #noStores>
            <h3 class="ion-margin-vertical ion-padding-vertical">
              There are currently no stores
              <span *ngIf="selectedCategory?.title"
                >in {{selectedCategory?.title}}</span
              >
            </h3>
          </ng-template>
        </ion-text>
      </ng-container>

      <ng-template #storesList>
        <ion-grid>
          <ion-row>
            <ion-col
              size="12"
              size-sm="4"
              size-md="3"
              *ngFor="let item of stores; trackBy: trackByChild">
              <ion-card (click)="linkToDetail(item)" class="card-boxed">
                <div *ngIf="item.logoImage" class="card-img">
                  <app-img-format
                    [src]="item.logoImage"
                    [aspectRatio]="'16:9'"
                    [disableLazyLoad]="true"
                    [alt]="item.title + ' in ' + environmentName"></app-img-format>
                </div>
                <ion-card-header>
                  <ion-card-subtitle>
                    <ng-container
                      *ngIf="item.typeGeneral.new && item.currentStatus.toLowerCase().includes('open')">
                      New Store |
                    </ng-container>
                    <ng-container
                      *ngIf="item.typeGeneral.popup && item.currentStatus.toLowerCase().includes('open')">
                      Pop-Up |
                    </ng-container>
                    {{item.currentStatus}}
                    <ng-container
                      *ngIf="item.currentStatus.toLowerCase().includes('open')">
                      | {{ storeOpenClose(item) }}
                    </ng-container>
                  </ion-card-subtitle>
                  <ion-card-title>{{item.title}}</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  {{item.typeGeneral.telephone_number}} |
                  {{item.typeGeneral.level}}
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-template>
    </div>

    <div
      *ngIf="selectedCategory && stores"
      class="ion-align-items-center ion-text-md-left ion-text-center">
      <ion-text class="h5"
        >End of {{ selectedCategory ? getFilteredRecords() :
        this.data.items.length }} store results</ion-text
      >

      <app-button class="search-btn" (click)="searchAgain()" type="secondary"
        >Search again</app-button
      >
    </div>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
